import { render } from "./AssignModal.vue?vue&type=template&id=76f8bb32&scoped=true"
import script from "./AssignModal.vue?vue&type=script&lang=js"
export * from "./AssignModal.vue?vue&type=script&lang=js"

import "./AssignModal.vue?vue&type=style&index=0&id=76f8bb32&scoped=true&lang=css"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76f8bb32"]])

export default __exports__